module.exports = __webpack_public_path__ + "img/aruba.fcd7c184.svg";